export default __webpack_public_path__ + "static/media/374.1cce7096.png";